import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4e6hayu5vx: FaireBrandEntity = {
  token: "b_4e6hayu5vx",
  type: "brand",
  name: "SS handcrafted Art",
  avatarUrl:
    "https://cdn.faire.com/fastly/a4ce896400ab50a7d3c8113141eff36b819d3957d2e0af66346283f06c6e40e2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/460d6323011da61b05bcaf9c11e00457ea2d84cf24f027420fbc4855206ae4cc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a4ce896400ab50a7d3c8113141eff36b819d3957d2e0af66346283f06c6e40e2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/460d6323011da61b05bcaf9c11e00457ea2d84cf24f027420fbc4855206ae4cc.jpeg",
  location: "mooresville, NC, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 140,
  isTopShop: true,
  isInsider: true,
  description:
    "We are excited to be here to share our handcrafted items with you. \n\nWe started this journey 20 years ago, when we met and cultivated an amazing relationship with an artisan family in Ecuador.\n\nThe Turtleman Foundation was founded by Joseph, also known as “The Turtleman”. Founded with a goal to be able to give back to the cause of helping in saving the sea turtles, aiding in ocean conservation, and giving back to his passion, the ocean.\n\n#savingtheturtles #handcrafted #ecuador #marble #theturtlemanfounation #seaturtles\n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.565Z",
    importedBy: "entity-db-cli",
  },
};
